import { createEventDefinition } from 'ts-bus';

export const EVENT_REFRESH_DATA = 'EVENT_REFRESH_DATA';

export const refreshData = createEventDefinition<() => void>()(EVENT_REFRESH_DATA);
